import { Pipe, PipeTransform } from '@angular/core';

import { enclosuresFieldHeightIsBiggerThenMax } from '../../enclosure/helpers/prisma.helper';
import { EnclosureTabType } from '../../shared/models/project.model';

@Pipe({
    name: 'zoomInUnavailable',
    standalone: false
})
export class ZoomInUnavailablePipe implements PipeTransform {

  transform(zoomLevel: number,
            enclosureConfigurationRows: number,
            enclosureConfigurationFields: number,
            maxRows: number,
            maxFields: number,
            mainContent: HTMLElement,
            tab: EnclosureTabType): boolean {
    if (!mainContent || tab !== EnclosureTabType.CONFIGURATION) {
      return false;
    }
    return enclosuresFieldHeightIsBiggerThenMax(mainContent,
      zoomLevel,
      enclosureConfigurationRows,
      enclosureConfigurationFields,
      maxRows,
      maxFields);
  }

}
